<template>
  <v-card class="inspection-sheet-dialog" style="overflow-x: hidden" elevation="0">
    <v-toolbar dense class="hide-for-inspection-sheet">
      <v-container fluid class="d-flex px-0 px-sm-3 py-0">
        <v-toolbar-title>Inspection Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            class="mr-1"
            depressed
            small
            @click="legacyPrint"
        >
          <v-icon small>mdi-printer</v-icon> Print
        </v-btn>
        <v-btn
            color="error"
            small
            @click="$emit('close')"
            class="ml-3 px-0 min-width"
        >
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-container>
    </v-toolbar>
    <v-container fluid class="px-1 px-sm-2">
      <v-overlay :value="loading">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-card
          id="sheet-card"
          :elevation="$vuetify.breakpoint.name === 'xs' ? 0 : 1"
          v-if="! loading">
        <v-card-text class="pa-0 pa-sm-4">
          <AppCardHeader v-if="sheetData.follow_ups.length">Open Follow-ups</AppCardHeader>
          <template v-for="note in sheetData.follow_ups.flatMap(followup => followup.follow_up_notes)">
            <v-row :key="note.id" dense>
              <v-col cols="12" class="font-weight-medium">{{ note.created}} - {{ note.created_by.display_name }}</v-col>
              <v-col cols="12" class="pl-4">{{ note.note}}</v-col>
            </v-row>
          </template>
          <AppCardHeader>General Info</AppCardHeader>
          <v-row>
            <!-- left column-->
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Company Name"
                  :cell="sheetData.company_name"/>
              <AppTableRow
                  header="Date/Time"
                  :cell="(! sheetData.canceled) ? sheetData.datetime : ''"/>
              <AppTableRow
                  header="Ordered By"
                  :cell="sheetData.ordered_by_type"/>
              <AppTableRow
                  header="Taken By"
                  :cell="sheetData.taken_by"/>
            </v-col>
            <!-- right column-->
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Status"
                  :cell="sheetData.status"/>
              <AppTableRow
                  header="Inspector"
                  :cell="sheetData.inspectors"/>
              <AppTableRow
                  v-if="sheetData.canceled && sheetData.canceled_by"
                  header="Canceled By"
                  :cell="sheetData.canceled_by"/>
              <AppTableRow
                  v-if="sheetData.canceled && sheetData.canceled_by"
                  header="Cancel Reason"
                  :cell="sheetData.cancel_reason"/>
            </v-col>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  v-if="sheetData.appointment_note"
                  header="Comments"
                  :cell="sheetData.appointment_note"/>
            </v-col>
          </v-row>
          <AppCardHeader>Client Info</AppCardHeader>
        <!-- client-->
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Client's Name"
                  :cell="sheetData.client.display_name"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Client at Inspection?"
                  :cell="sheetData.client_attending"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  :cell="sheetData.client.full_address"
                  header="Address"
                  map
              />
            </v-col>
          </v-row>
          <!-- client contact-->
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.client.home_phone_number"
                  :cell="sheetData.client.home_phone_number"
                  header="Home phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.client.mobile_phone_number"
                  :cell="sheetData.client.mobile_phone_number"
                  header="Cell Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.client.work_phone_number"
                  :cell="sheetData.client.work_phone_number"
                  header="Work Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.client.email_address"
                  :cell="sheetData.client.email_address"
                  email
                  header="Email"
              />
            </v-col>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Comments"
                  v-if="sheetData.client_note"
                  :cell="sheetData.client_note"/>
            </v-col>
          </v-row> <!-- end client-->
          <!-- property info-->
          <AppCardHeader>Property Info</AppCardHeader>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Address"
                  :cell="sheetData.full_address"
                  map
              />
              <AppTableRow
                  header="Cross Street"
                  v-if="sheetData.cross_street"
                  :cell="sheetData.cross_street"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Occupied"
                  v-if="sheetData.property_occupied"
                  :cell="sheetData.property_occupied"/>
              <AppTableRow
                  header="Utilities ON"
                  v-if="sheetData.utilities_on"
                  :cell="sheetData.utilities_on"/>
              <AppTableRow
                  header="Neighborhood"
                  v-if="sheetData.neighborhood"
                  :cell="sheetData.neighborhood"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Directions"
                  v-if="sheetData.direction"
                  :cell="sheetData.direction"/>
              <AppTableRow
                  header="Comments"
                  v-if="sheetData.property_note"
                  :cell="sheetData.property_note"/>
            </v-col>
          </v-row><!-- end property info-->
          <!--Access-->
          <AppCardHeader>Access</AppCardHeader>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Provided By"
                  v-if="sheetData.access.type"
                  :cell="sheetData.access.type"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="CBS Code"
                  v-if="sheetData.access.cbs_code"
                  :cell="sheetData.access.cbs_code"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Lockbox Code"
                  v-if="sheetData.access.lockbox_code"
                  :cell="sheetData.access.lockbox_code"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Gate Code"
                  v-if="sheetData.access.gate_code"
                  :cell="sheetData.access.gate_code"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Alarm Code"
                  v-if="sheetData.access.alarm_code"
                  :cell="sheetData.access.alarm_code"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="FSBO Contact Name"
                  v-if="sheetData.access.fsbo_name"
                  :cell="sheetData.access.fsbo_name"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.access.fsbo_phone"
                  :cell="sheetData.access.fsbo_phone"
                  header="FSBO Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.access.fsbo_email"
                  :cell="sheetData.access.fsbo_email"
                  email
                  header="FSBO Email"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Comments"
                  v-if="sheetData.access.note"
                  :cell="sheetData.access.note"/>
            </v-col>
          </v-row><!--end Access-->
          <!-- services and fees-->
          <AppCardHeader>Services and Fees</AppCardHeader>
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <div
                  v-for="(controls, label) in sheetData.xml"
                  :key="label"
              >
                <div
                    v-if="controls.filter(control => isTruthy(control.value)).length"
                    class="flex-grow-1"
                >
                  <v-divider></v-divider>
                  <div class="text-subtitle-2 font-weight-medium px-2 text-uppercase">{{ label }}</div>
                  <v-divider></v-divider>
                </div>
                <div
                    v-for="(control, index) in controls" :key="index"
                    class="d-flex"
                >
                  <div
                      v-if="isTruthy(control.value)"
                      class="text-caption font-weight-bold flex-grow-1 flex-basis-0 truncate px-2"
                  >{{ control.label }}
                  </div>
                  <div
                      v-if="isTruthy(control.value)"
                      class="flex-grow-1 flex-basis-0 text-right px-2"
                  >
                    {{ control.value }}
                  </div>
                </div>
              </div>
            </v-col>
            <!-- Fees-->
            <v-col cols="12" sm="6" class="py-0">
              <div
                  v-for="(fee, index) in sheetData.fees.data"
                  :key="index"
              >
                <div class="d-flex">
                  <div v-if="fee.type === 'section'" class="flex-grow-1">
                    <v-divider></v-divider>
                    <div class="text-subtitle-2 font-weight-medium px-2 text-uppercase">{{ fee.label }}</div>
                    <v-divider class="mb-1"></v-divider>
                  </div>
                  <div
                      v-if="isTruthy(fee.value) && fee.type !== 'section'"
                      class="text-caption font-weight-bold flex-grow-1 flex-basis-0 truncate px-2"
                  >
                    {{ fee.label }}
                  </div>
                  <div
                      v-if="isTruthy(fee.value) && fee.type !== 'section'"
                      class="flex-grow-1 flex-basis-0 text-right px-2"
                  >
                    {{ fee.value }}
                  </div>
                </div>
                <div
                    v-for="(subfee, index) in fee.subfees"
                    :key="index"
                    class="text-right text-caption px-2"
                >
                  {{ subfee.name }}: {{ subfee.value }}
                </div>
              </div>
              <div>
                <v-divider></v-divider>
                <div class="d-flex">
                  <div class="text-caption font-weight-bold flex-grow-1 flex-basis-0 px-2">Total</div>
                  <div class="flex-grow-1 flex-basis-0 text-right px-2">
                    ${{ parseFloat(sheetData.fees.total).toFixed(2) }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="pa-1 py-0">
              <AppTableRow
                  header="Comments"
                  v-if="sheetData.pricing_note"
                  :cell="sheetData.pricing_note"/>
            </v-col>
          </v-row><!--end Fees-->
          <!--Payment/Contract-->
          <AppCardHeader>Payment/Contract</AppCardHeader>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Contract"
                  v-if="sheetData.contract_type"
                  :cell="sheetData.contract_type"/>
              <AppTableRow
                  header="Will Pay"
                  v-if="sheetData.payment.willpay"
                  :cell="sheetData.payment.willpay"/>
              <AppTableRow
                  header="Payment Type"
                  v-if="sheetData.payment.type"
                  :cell="sheetData.payment.type"/>
            </v-col>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Comments"
                  v-if="sheetData.payment.note"
                  :cell="sheetData.payment.note"/>
            </v-col>
          </v-row><!--end Payment/Contract-->
          <!--Agents-->
          <AppCardHeader
              v-if="sheetData.seller_agent.id || sheetData.buyer_agent.id || sheetData.escrow_agent.id"
          >
            Agents
          </AppCardHeader>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Buyer Agent"
                  v-if="sheetData.buyer_agent.display_name"
                  :cell="sheetData.buyer_agent.display_name"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Agency"
                  v-if="sheetData.buyer_agent.agency_name"
                  :cell="sheetData.buyer_agent.agency_name"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.buyer_agent.full_address"
                  :cell="sheetData.buyer_agent.full_address"
                  header="Address"
                  map
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.buyer_agent.home_phone_number"
                  :cell="sheetData.buyer_agent.home_phone_number"
                  header="Home Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.buyer_agent.work_phone_number"
                  :cell="sheetData.buyer_agent.work_phone_number"
                  header="Work Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.buyer_agent.mobile_phone_number"
                  :cell="sheetData.buyer_agent.mobile_phone_number"
                  header="Mobile Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.buyer_agent.email_address"
                  :cell="sheetData.buyer_agent.email_address"
                  email
                  header="Email Address"
              />
            </v-col>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Buyer Agent Notes"
                  v-if="sheetData.buyer_agent_note"
                  :cell="sheetData.buyer_agent_note"/>
            </v-col>
          </v-row>
          <!--Seller Agent-->
          <v-divider class="my-3" v-if="sheetData.seller_agent.id && sheetData.buyer_agent.id"></v-divider>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Seller Agent"
                  v-if="sheetData.seller_agent.display_name"
                  :cell="sheetData.seller_agent.display_name"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Agency"
                  v-if="sheetData.seller_agent.agency_name"
                  :cell="sheetData.seller_agent.agency_name"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  header="Address"
                  v-if="sheetData.seller_agent.full_address"
                  :cell="sheetData.seller_agent.full_address"
                  map
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.seller_agent.home_phone_number"
                  :cell="sheetData.seller_agent.home_phone_number"
                  header="Home Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.seller_agent.work_phone_number"
                  :cell="sheetData.seller_agent.work_phone_number"
                  header="Work Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.seller_agent.mobile_phone_number"
                  :cell="sheetData.seller_agent.mobile_phone_number"
                  header="Mobile Phone"
                  phone
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.seller_agent.email_address"
                  :cell="sheetData.seller_agent.email_address"
                  email
                  header="Email Address"
              />
            </v-col>
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  header="Seller Agent Notes"
                  v-if="sheetData.seller_agent_note"
                  :cell="sheetData.seller_agent_note"/>
            </v-col>
          </v-row>
          <v-divider class="my-3" v-if="sheetData.seller_agent.id || sheetData.buyer_agent.id"></v-divider>
          <!--Escrow Agent-->
          <v-row>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.display_name"
                  :cell="sheetData.escrow_agent.display_name"
                  header="Escrow Agent"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.agency_name"
                  :cell="sheetData.escrow_agent.agency_name"
                  header="Company"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.full_address"
                  :cell="sheetData.escrow_agent.full_address"
                  header="Address"
                  map
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.work_phone_number"
                  :cell="sheetData.escrow_agent.work_phone_number"
                  header="Work Phone"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.work_fax_number"
                  :cell="sheetData.escrow_agent.work_fax_number"
                  header="Fax"/>
            </v-col>
            <v-col cols="12" sm="6" class="pa-0">
              <AppTableRow
                  v-if="sheetData.escrow_agent.email_address"
                  :cell="sheetData.escrow_agent.email_address"
                  header="Email"/>
            </v-col>
          </v-row><!--End Escrow Agent-->
          <!--Referred-->
          <v-row v-if="sheetData.referred_reason">
            <v-col cols="12" class="pa-0">
              <AppTableRow
                  v-if="sheetData.referred_reason"
                  :cell="sheetData.referred_reason"
                  header="Referred By"/>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import AppCardHeader from "./sheet/AppCardHeader";
import AppTableRow from "./sheet/AppTableRow";


export default {
  name: 'InspectionSheet',
  components: {AppTableRow, AppCardHeader},
  props: ['inspectionId'],
  inject: {
    theme: {
      default: {isDark: false},
    },
  },
  data() {
    return {
      sheetData: [],
      loading: true,
      feeTotal: 0,
    }
  },
  watch: {
    inspectionId: {
      immediate: true,
      handler() {
        this.resetState()
        this.retrieveSheetData(this.inspectionId)
            .then(response => this.sheetData = response.data)
            .then(() => this.loading = false)
      },
    },
  },
  methods: {
    ...mapActions(['retrieveSheetData']),
    print() {
      window.setTimeout(() => window.print(), 200) // Give the menu a chance to close
    },
    legacyPrint() {
      const url = `https://cornerstone2.net/orders/newprintinspectionsheet?uuid=${this.sheetData.uuid}&key=${this.sheetData.key}`
      window.open(url, '_blank')
    },
    resetState() {
      this.sheetData = []
      this.loading = true
      this.feeTotal = 0
    },
    isFalsy(value) {
      return ['', 0, '0', null, undefined, false, 'false'].includes(value)
    },
    isTruthy(value) {
      return ! this.isFalsy(value)
    },
  },
}
</script>

<style scoped>
.min-width {
  min-width: 16px !important;
}
.flex-basis-0 {
  flex-basis: 0;
}
.truncate {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>

<style>
@media print {
  * {
    -webkit-print-color-adjust: exact;
  }
  #sheet-card, .v-dialog--fullscreen .v-card {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  html, body {
    height: 99% !important;
    margin: 0 !important;
    padding: 0 !important;
    page-break-after: avoid;
    page-break-before: avoid;
  }
  div.v-application--wrap {
    min-height: 0 !important;
  }
}
</style>